var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid mainPage"},[_c('app-mainPageCarousel'),_c('app-companyinfo'),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }